import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { noop, Observable } from "rxjs";
import { debounceTime, switchMap, map, tap } from "rxjs/operators";
import { AuthService } from "src/app/core/service/auth.service";
import { DrugService } from "src/app/shared/drug.service";
import { DrugServiceService } from "src/app/shared/drug/drug-service.service";
import { Drug } from "src/app/shared/models/drug";
import { PrescriptionCode } from "src/app/shared/models/prescriptionCode";
import { PrescriptionService } from "../../prescription.service";

@Component({
  selector: "app-replace-modal",
  templateUrl: "./replace-modal.component.html",
  styleUrls: ["./replace-modal.component.sass"],
})
export class ReplaceModalComponent implements OnInit {
  drug: any;
  replaceDrugForm: FormGroup;
  filteredDrugs$: Observable<Drug[]>;
  replacedDrug: any;
  currentDate: Date;
  filteredPrescriptionCode$: Observable<PrescriptionCode[]>;
  prescriptionCode: PrescriptionCode;
  constructor(
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private drugService: DrugServiceService,
    public dialogRef: MatDialogRef<ReplaceModalComponent>,
    private prescriptionService: PrescriptionService,
    private authService: AuthService
  ) {
    this.drug = data.drug;
    this.replaceDrugForm = this.formBuilder.group({
      drugName: ["", Validators.required],
      description: ["", Validators.required],
      remark: ["", Validators.required],
      codeName: [null],
      refill: [""],
    });
    this.currentDate = new Date();
  }

  ngOnInit(): void {
    this.filteredDrugs$ = this.replaceDrugForm
      .get("drugName")
      .valueChanges.pipe(
        debounceTime(300),
        switchMap((value) => {
          return this.drugService.ListDrug(value).pipe(
            map((data: any) => (data && data?.Rows) || []),
            tap(
              () => noop,
              (err) => {}
            )
          );
        })
      );

    this.filteredPrescriptionCode$ = this.replaceDrugForm
      .get("codeName")
      .valueChanges.pipe(
        debounceTime(300),
        switchMap((value) => {
          return this.prescriptionService
            .GetPrescriptionCode({
              name: value,
            })
            .pipe(
              map((data: any) => (data && data.Rows) || []),
              tap(
                () => noop,
                (err) => {}
              )
            );
        })
      );
  }

  closeDialog(): void {
    this.dialog.closeAll();
  }
  ReplaceDrug() {
    if (this.replaceDrugForm.valid) {
      var drug = {
        Name: this.replacedDrug.option.value.Name,
        Description: this.replaceDrugForm.get("description").value,
        Refill:this.replaceDrugForm.get("refill").value,
        Remark: this.replaceDrugForm.get("remark").value,
        Status: "Replaced",
        PrescriptionId: this.drug.PrescriptionId,
        OldDrugId: this.drug.DrugId,
        NewDrugId: this.replacedDrug.option.value.Id,
        Date: this.currentDate,
        PrescriptionDetailsId: this.drug.Id,
        OldDrugDescription: this.drug.Description,
        OldDrugRefill: this.drug.Refill,
      };
      this.dialogRef.close(drug);
    }
  }

  displayFn2(drug: Drug) {
    if (drug) {
      return drug.Name;
    }
  }
  displayFn3(code: PrescriptionCode) {
    if (code) {
      return code.Code;
    }
  }
  selectedDrug(option) {
    this.replacedDrug = option;
    if (this.replacedDrug.option.value.Id == this.drug.DrugId) {
      this.replaceDrugForm.controls.drugName.setValue(null);
      this.authService.showNotification(
        "snackbar-danger",
        "This drug already prescribed.",
        "top",
        "center"
      );
    }
  }
  selectedPrescriptionCode(option) {
    this.prescriptionCode = option?.option?.value;
    this.replaceDrugForm.controls.description.setValue(
      this.prescriptionCode.Description
    );
  }
}
